"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stylable_panel_common_1 = require("@wix/stylable-panel-common");
//# sourceMappingURL=types.js.map